export default __webpack_public_path__ + "static/media/error.ea336651.png";